export default {"src":"/_next/static/media/spinner.75656d9c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};